import React from 'react';
import { AiOutlineClockCircle } from 'react-icons/ai';

const Blog = () => {
    return (
        <div className=''>
            <h1 className='text-4xl font-semibold h-screen flex justify-center items-center'>
                <AiOutlineClockCircle className="w-12 h-12 mr-2" />
                Stay Tuned for Exciting Content Coming Soon!
            </h1>
        </div>
    );
};

export default Blog;
